import { normalizeSeoPath, SERVICE_PATHS } from './urls';

export const DUPLICATE_PARAMS = [
  'm-message-key-id', 'referrer', 'page', 'utm_order_number', 'ref',
  'brid', 'amp', 'id', 'xid', 'name',
];
export const NOINDEX_PATHS = [...SERVICE_PATHS, '/about', '/static', '/server', '/404'];

export const isNoIndexRequest = (pathname: string, query = ''): boolean => {
  const path = normalizeSeoPath(pathname);
  return NOINDEX_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`)) ||
    DUPLICATE_PARAMS.some((key) => new URLSearchParams(query).has(key));
};

export const buildRobotsTxt = (origin: string, allowNoindexCrawl = false): string => {
  const lines = ['User-agent: *'];
  if (!allowNoindexCrawl) {
    // Match complete query keys, not e.g. product_id or username.
    DUPLICATE_PARAMS.forEach((key) => lines.push(`Disallow: /*?${key}=`, `Disallow: /*?*&${key}=`));
    [...SERVICE_PATHS, '/about'].forEach((path) => lines.push(
      `Disallow: ${path}$`, `Disallow: ${path}?*`, `Disallow: ${path}/`,
    ));
  }
  lines.push(
    'Disallow: /server/',
    'Disallow: /static/',
    // CRA resources are needed to render the public React pages.
    'Allow: /static/js/', 'Allow: /static/css/', 'Allow: /static/media/',
    '# page controls application screens and must not be treated as tracking.',
    `Clean-param: ${DUPLICATE_PARAMS.filter((key) => key !== 'page').join('&')} /`,
    `Sitemap: ${new URL('/sitemap.xml', `${origin}/`).toString()}`,
  );
  return `${lines.join('\n')}\n`;
};
